import fetch from '@/api/fetch'

/** 查询人员工资条列表（根据状态查询） */
export const getWageAuditList = wageQuery => fetch.post('/ent/wage/slip/query', wageQuery);

/** 查询人员工资条分组统计列表（根据状态查询） */
export const getWageTotalList = wageQuery => fetch.post('/ent/wage/slip/queryTotal', wageQuery);

/**导入工资条保存 */
export const wageAuditUploadSave = (data, params) => fetch.post('/ent/wage/slip/upload', data, { params });

/**导出工资条导入模板 */
export const wageAuditLoadModel = ( data) => fetch.post('/ent/wage/slip/loadModel', data,{responseType:'blob'});

/**查询工资条统计 */
export const getSlipStatistics = (params) => fetch.get('/ent/wage/slip/statistics',  { params });

/**获取所有工资状态枚举 */
export const getSilpEnum = () => fetch.get('/index/wage/status/all');

/**获取所有工种工资上限 */
export const getWorkWageList = () => fetch.get('/ent/wage/slip/wageworktype');

/**工资条发送（批量与单个） */
export const sendWageSlip = ( data) => fetch.post('/ent/wage/slip/sendWageSlip', data);

/**工资发放（批量与单个） */
export const grantWageSlip = ( data) => fetch.post('/ent/wage/slip/grantWageSlip', data);

/**导出工资条数据 */
export const loadWageSlip = ( data) => fetch.post('/ent/wage/slip/loadWageSlip', data,{responseType:'blob'});

/**工资条审核（批量与单个） */
export const auditWageSlip = ( data) => fetch.post('/ent/wage/slip/auditWageSlip', data);

/**导出薪酬报表数据 */
export const loadWageSlipTotal = ( data) => fetch.post('/ent/wage/slip/loadWageSlipTotal', data,{responseType:'blob'});


/** 获取薪酬统计页面统计 */
export const getSlipTotalStatistics = params => fetch.get('/ent/wage/slip/total/statistics', { params })

/**工资删除（批量与单个） */
export const deleteWageSlip = ( data) => fetch.post('/ent/wage/slip/rmvByIds', data);

/**更新工资条图片附件 */
export const updateWageAttr = ( data) => fetch.post('/ent/wage/updateAttr', data);
/** 附件上传 */
export const uploadWageFile = fs => fetch.post('/file/uploadWage', fs,{'X-Requested-With': 'XMLHttpRequest'});
/** 附件删除 */
export const delWageFile = path => fetch.post('/ent/wage/delFile',path);